import { createSelector } from 'reselect'

const getRegionsOptions: SelectOptionsSelector = (state) =>
  state.regions.regionsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const regionsSelectOptionsSelector: SelectOptionsSelector = createSelector(getRegionsOptions, (options) => options)
